import * as actionTypes from './actionTypes';
import reduce from '../reduce';

const initialState = {
    crowdGroups: [],
    error: ''
}

const receivedCrowdGroupsData=(state, action)=>{
    return {
        ...state,
        crowdGroups: action.crowdGroups
    }
}

const unknownServerError=(state, action)=> {
    return {
        ...state,
        error: action.error
    }
}

export default reduce(initialState,{
    [actionTypes.GET_CROWD_GROUPS_DATA]: receivedCrowdGroupsData,
    [actionTypes.CROWD_GROUPS_SERVER_ERROR]: unknownServerError 
});


// WEBPACK FOOTER //
// ./src/redux/crowdGroup/reducer.js